import React, { Fragment, useState, useEffect } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Form } from 'react-bootstrap';
import AdminLandsaleService from "../../../API/Services/AdminService/AdminLandsaleService";
import swal from "sweetalert";
import Select from "react-select";
import MainPagetitle from "../../layouts/MainPagetitle";
import ClipLoader from "react-spinners/ClipLoader";
import AdminBuilderService from "../../../API/Services/AdminService/AdminBuilderService";
import LazySubdivisionMultiSelect from "../../components/LazySubdivisionMultiSelect";

const LandsaleUpdate = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const page = queryParams.get("page");

    const params = useParams();
    const navigate = useNavigate();

    const [isLoadingLandSale, setIsLoadingLandSale] = useState(false);
    const [isLoadingBuilder, setIsLoadingBuilder] = useState(false);
    const [builderCode, setBuilderCode] = useState([]);
    const [SubdivisionCode, setSubdivisionCode] = useState([]);
    const [masterPlanCode, setMasterPlanCode] = useState([]);
    const [Error, setError] = useState('');
    const [builderListDropDown, setBuilderListDropDown] = useState([]);
    const [masterPlanDropDownList, setMasterPlanDropDownList] = useState([]);
    const [LandsaleList, SetLandsaleList] = useState([]);
    const [noOfUnit, setNoOfUnit] = useState(null);
    const [price, setPrice] = useState(null);

    const formatNoOfUnit = (value) => {
        if (value === null || value === undefined || value === "") {
            return "";
        }

        const numericValue = Number(value);
        return Number.isNaN(numericValue) ? value : numericValue.toFixed(4);
    };

    useEffect(() => {
        if (localStorage.getItem('usertoken')) {
            ShowLandSales(params.id);
            GetBuilderDropDownList();
            GetMasterPlanDropDownList();
        }
        else {
            navigate('/');
        }
    }, []);

    useEffect(() => {
        if (LandsaleList?.subdivision_id) {
            setSubdivisionCode({
                label:
                    LandsaleList?.subdivision?.name ||
                    LandsaleList?.subdivision_name ||
                    LandsaleList?.subdivision?.subdivision_code ||
                    String(LandsaleList.subdivision_id),
                value: LandsaleList.subdivision_id,
                masterplan_id: LandsaleList?.subdivision?.masterplan_id || null,
                builder_id:
                    LandsaleList?.subdivision?.builder_id ||
                    LandsaleList?.subdivision?.builder?.id ||
                    null,
            });
        } else {
            setSubdivisionCode([]);
        }
    }, [LandsaleList]);

    useEffect(() => {
        if (!LandsaleList || builderListDropDown.length === 0) return;

        const builderId =
            LandsaleList?.builder_id ||
            LandsaleList?.subdivision?.builder_id ||
            LandsaleList?.subdivision?.builder?.id;

        if (!builderId) {
            setBuilderCode([]);
            return;
        }

        const matchedBuilder = builderListDropDown.find(
            (item) => String(item.value) === String(builderId)
        );

        if (matchedBuilder) {
            handleBuilderCode(matchedBuilder, false);
            return;
        }

        const fallbackName =
            LandsaleList?.builder?.name ||
            LandsaleList?.subdivision?.builder?.name;

        if (fallbackName) {
            handleBuilderCode(
                { label: fallbackName, value: builderId },
                false
            );
        }
    }, [LandsaleList, builderListDropDown]);

    useEffect(() => {
        if (!LandsaleList || masterPlanDropDownList.length === 0) return;

        const directMasterPlan = LandsaleList?.masterplan_id;
        const subdivisionMasterPlan = LandsaleList?.subdivision?.masterplan_id;

        const masterPlanValue =
            directMasterPlan !== null &&
                directMasterPlan !== undefined &&
                String(directMasterPlan).trim() !== ""
                ? directMasterPlan
                : subdivisionMasterPlan;

        if (
            masterPlanValue === null ||
            masterPlanValue === undefined ||
            String(masterPlanValue).trim() === ""
        ) {
            setMasterPlanCode([]);
            return;
        }

        const matchedMasterPlan = masterPlanDropDownList.find(
            (item) =>
                String(item.value).trim().toLowerCase() ===
                String(masterPlanValue).trim().toLowerCase()
        );

        setMasterPlanCode(
            matchedMasterPlan || {
                label: String(masterPlanValue),
                value: masterPlanValue,
            }
        );
    }, [LandsaleList, masterPlanDropDownList]);

    const ShowLandSales = async (id) => {
        setIsLoadingLandSale(true);
        try {
            let responseData = await AdminLandsaleService.show(id).json();
            SetLandsaleList(responseData);
            setPrice(responseData.price);
            setNoOfUnit(responseData.noofunit);
            setIsLoadingLandSale(false);
        } catch (error) {
            setIsLoadingLandSale(false);
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message);
            }
        }
    };

    const GetBuilderDropDownList = async () => {
        setIsLoadingBuilder(true);
        try {
            const response = await AdminBuilderService.builderDropDown();
            const responseData = await response.json();
            const formattedData = [
                { label: "Select Builder None", value: "" }, // Default option
                ...responseData.map((builder) => ({
                    label: builder.name,
                    value: builder.id,
                })),
            ];
            setIsLoadingBuilder(false);
            setBuilderListDropDown(formattedData);
        } catch (error) {
            setIsLoadingBuilder(false);
            if (error.name === "HTTPError") {
                const errorJson = await error.response.json();
                setError("Something went wrong!");
            }
        }
    };

    const handleBuilderCode = (code, resetSubdivision = true) => {
        setBuilderCode(code);
        if (resetSubdivision) {
            setSubdivisionCode([]);
        }
    };

    const GetMasterPlanDropDownList = async () => {
        setIsLoadingBuilder(true);
        try {
            const response = await AdminBuilderService.masterPlanDropDown();
            const responseData = await response.json();
            setMasterPlanDropDownList([
                { label: "Select Master Plan None", value: "" },
                ...responseData,
            ]);
            setIsLoadingBuilder(false);
        } catch (error) {
            setIsLoadingBuilder(false);
            setError("Something went wrong!");
        }
    };

    const handleSubdivisionCode = (code) => {
        setSubdivisionCode(code);

        // If subdivision is removed, keep the current Master Plan selection.
        // A Master Plan is allowed to exist independently when there is no
        // subdivision.
        if (!code || code.value === "" || code.value === null || code.value === undefined) {
            return;
        }

        // When a subdivision is selected/changed, automatically load that
        // subdivision's Master Plan when it has one.
        if (code.masterplan_id) {
            const matchedMasterPlan = masterPlanDropDownList.find(
                (item) =>
                    String(item.value).trim().toLowerCase() ===
                    String(code.masterplan_id).trim().toLowerCase()
            );

            setMasterPlanCode(
                matchedMasterPlan || {
                    label: String(code.masterplan_id),
                    value: code.masterplan_id,
                }
            );
        } else {
            // New subdivision has no Master Plan -> clear the previous one.
            setMasterPlanCode({ label: "Select Master Plan None", value: "" });
        }
    };

    const handleMasterPlanCode = (code) => {
        setMasterPlanCode(code);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            var userData = {
                "seller": event.target.seller.value,
                "buyer": event.target.buyer.value,
                "location": event.target.location.value,
                "date": event.target.date.value,
                "parcel": event.target.parcel.value,
                "price": event.target.price.value,
                "typeofunit": event.target.typeofunit.value,
                "noofunit": event.target.noofunit.value,
                "notes": event.target.notes.value,
                "doc": event.target.doc.value,
                "zoning": event.target.zoning.value,
                "lat": event.target.lat.value,
                "lng": event.target.lng.value,
                "area": event.target.area.value,
                "zip": event.target.zip.value,
                "subdivision_id": (SubdivisionCode?.value === "" || SubdivisionCode?.value === undefined || SubdivisionCode?.value === null) ? null : SubdivisionCode?.value,
                "masterplan_id": (masterPlanCode?.value === "" || masterPlanCode?.value === undefined || masterPlanCode?.value === null) ? null : masterPlanCode?.value,
                "builder_id": (builderCode?.value === "" || builderCode?.value === undefined || builderCode?.value === null) ? null : builderCode?.value,
            }

            const data = await AdminLandsaleService.update(params.id, userData).json();

            if (data.status === true) {
                swal("Record Updated Successfully").then((willDelete) => {
                    if (willDelete) {
                        navigate(`/landsalelist?page=${page}`);
                    }
                })
            }
        }
        catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")));
            }
        }
    };

    return (
        <Fragment>
            <MainPagetitle mainTitle="Edit Land Sale" pageTitle="Edit Land Sale" parentTitle="Land Sales" link={`/landsalelist?page=${page}`} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Land Sale</h4>
                            </div>
                            {(isLoadingLandSale || isLoadingBuilder) ? (
                                <div className="d-flex justify-content-center align-items-center mb-5 mt-5">
                                    <ClipLoader color="#4474fc" />
                                </div>
                            ) : (
                                <div className="card-body">
                                    <div className="form-validation">
                                        <form onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-xl-6 mb-3">
                                                    <label className="form-label">Builder</label>
                                                    <Form.Group controlId="tournamentList">
                                                        <Select
                                                            name="builder_id"
                                                            options={builderListDropDown}
                                                            value={builderCode}
                                                            placeholder={"Select Builder..."}
                                                            onChange={(selectedOption) => handleBuilderCode(selectedOption)}
                                                            styles={{
                                                                container: (provided) => ({
                                                                    ...provided,
                                                                    width: '100%',
                                                                    color: 'black'
                                                                }),
                                                                menu: (provided) => ({
                                                                    ...provided,
                                                                    width: '100%',
                                                                    color: 'black'
                                                                }),
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label className="form-label">Subdivision</label>
                                                    <Form.Group controlId="tournamentList">
                                                        <LazySubdivisionMultiSelect
                                                            name="subdivision_id"
                                                            builderIds={(builderCode?.value === "" || builderCode?.value === undefined || builderCode?.value === null) ? [] : [builderCode.value]}
                                                            value={SubdivisionCode}
                                                            placeholder={"Select Subdivision..."}
                                                            onChange={(selectedOption) => handleSubdivisionCode(selectedOption)}
                                                            isMulti={false}
                                                        />
                                                    </Form.Group>
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label className="form-label">Master Plan</label>
                                                    <Form.Group controlId="masterPlanList">
                                                        <Select
                                                            name="masterplan_id"
                                                            options={masterPlanDropDownList}
                                                            value={masterPlanCode}
                                                            placeholder={"Select Master Plan..."}
                                                            onChange={(selectedOption) => handleMasterPlanCode(selectedOption)}
                                                            styles={{
                                                                container: (provided) => ({
                                                                    ...provided,
                                                                    width: '100%',
                                                                    color: 'black'
                                                                }),
                                                                menu: (provided) => ({
                                                                    ...provided,
                                                                    width: '100%',
                                                                    color: 'black'
                                                                }),
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput2" className="form-label">Seller <span className="text-danger">*</span></label>
                                                    <input type="text" defaultValue={LandsaleList.seller} name='seller' className="form-control" id="exampleFormControlInput2" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput3" className="form-label">Buyer <span className="text-danger">*</span></label>
                                                    <input type="text" defaultValue={LandsaleList.buyer} name='buyer' className="form-control" id="exampleFormControlInput3" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput4" className="form-label">Location <span className="text-danger">*</span></label>
                                                    <input type="text" name='location' defaultValue={LandsaleList.location} className="form-control" id="exampleFormControlInput4" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput5" className="form-label">Date <span className="text-danger">*</span></label>
                                                    <input type="date" defaultValue={LandsaleList.date} name='date' className="form-control" id="exampleFormControlInput5" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput6" className="form-label">Parcel</label>
                                                    <input type="text" name='parcel' defaultValue={LandsaleList.parcel} className="form-control" id="exampleFormControlInput6" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput7" className="form-label">Price ($)</label>
                                                    <input type="number" defaultValue={LandsaleList.price} name='price' className="form-control" id="exampleFormControlInput7" placeholder="" onChange={(e) => setPrice(e.target.value)} onWheel={(e) => e.currentTarget.blur()} onKeyDown={(e) => (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()} />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput10" className="form-label">Type of Unit</label>
                                                    <input type="text" name='typeofunit' defaultValue={LandsaleList.typeofunit} className="form-control" id="exampleFormControlInput10" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput11" className="form-label">Price Per Unit ($)</label>
                                                    <input type="number" value={noOfUnit ? Math.floor(price / noOfUnit) : 0} disabled style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }} name='priceperunit' className="form-control" id="exampleFormControlInput11" placeholder="" onWheel={(e) => e.currentTarget.blur()} onKeyDown={(e) => (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()} />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput12" className="form-label">No. Of Unit</label>
                                                    <input type="number" step="any" name='noofunit' defaultValue={formatNoOfUnit(LandsaleList.noofunit)} className="form-control" id="exampleFormControlInput12" placeholder="" onChange={(e) => setNoOfUnit(e.target.value)} onWheel={(e) => e.currentTarget.blur()} onKeyDown={(e) => (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()} />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput16" className="form-label">Notes</label>
                                                    <input type="text" name='notes' defaultValue={LandsaleList.notes} className="form-control" id="exampleFormControlInput16" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput17" className="form-label">Doc</label>
                                                    <input type="text" name='doc' defaultValue={LandsaleList.doc} className="form-control" id="exampleFormControlInput17" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput17" className="form-label">Zoning</label>
                                                    <input type="text" defaultValue={LandsaleList.zoning} name='zoning' className="form-control" id="exampleFormControlInput17" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput17" className="form-label">Latitude</label>
                                                    <input type="text" name='lat' defaultValue={LandsaleList.lat} className="form-control" id="exampleFormControlInput17" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput17" className="form-label">Longitude</label>
                                                    <input type="text" name='lng' defaultValue={LandsaleList.lng} className="form-control" id="exampleFormControlInput17" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput17" className="form-label">Area</label>
                                                    <input type="text" defaultValue={LandsaleList.area} name='area' className="form-control" id="exampleFormControlInput17" placeholder="" />
                                                </div>

                                                <div className="col-xl-6 mb-3">
                                                    <label htmlFor="exampleFormControlInput17" className="form-label">ZIP Code</label>
                                                    <input type="text" name='zip' defaultValue={LandsaleList.zip} className="form-control" id="exampleFormControlInput17" placeholder="" />
                                                </div>

                                                <p className='text-danger fs-12'>{Error}</p>
                                            </div>

                                            <div>
                                                <button type="submit" className="btn btn-primary me-1">Submit</button>
                                                <Link to={`/landsalelist?page=${page}`} className="btn btn-danger light ms-1">Cancel</Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default LandsaleUpdate;
